import apiClient from './client';
import type {
  Team,
  TeamDetails,
  TeamMember,
  CreateTeamRequest,
  UpdateTeamRequest,
  AddTeamMemberRequest,
} from '../types';

export const teamsApi = {
  // Get all teams for current user
  getAll: async (): Promise<Team[]> => {
    const response = await apiClient.get<Team[]>('/teams');
    return response.data;
  },

  // Get team details with members and series
  getById: async (id: string): Promise<TeamDetails> => {
    const response = await apiClient.get<TeamDetails>(`/teams/${id}`);
    return response.data;
  },

  // Create new team
  create: async (data: CreateTeamRequest): Promise<Team> => {
    const response = await apiClient.post<Team>('/teams', data);
    return response.data;
  },

  // Update team
  update: async (id: string, data: UpdateTeamRequest): Promise<Team> => {
    const response = await apiClient.put<Team>(`/teams/${id}`, data);
    return response.data;
  },

  // Delete team
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/teams/${id}`);
  },

  // Get team members
  getMembers: async (teamId: string): Promise<TeamMember[]> => {
    const response = await apiClient.get<TeamMember[]>(`/teams/${teamId}/members`);
    return response.data;
  },

  // Add member to team
  addMember: async (teamId: string, data: AddTeamMemberRequest): Promise<TeamMember> => {
    const response = await apiClient.post<TeamMember>(`/teams/${teamId}/members`, data);
    return response.data;
  },

  // Update member role
  updateMemberRole: async (teamId: string, userId: string, role: 'owner' | 'member'): Promise<void> => {
    await apiClient.put(`/teams/${teamId}/members/${userId}`, { role });
  },

  // Remove member from team
  removeMember: async (teamId: string, userId: string): Promise<void> => {
    await apiClient.delete(`/teams/${teamId}/members/${userId}`);
  },
};
